// © Microsoft Corporation. All rights reserved.

import { getFlight } from "./getFlight";

const businessInsiderPublisherId = "AA28VO";

export function shouldUseMoreFromPublisherFollowApi (publisherId: string) {
    if (getFlight("prg-publv1") && publisherId === businessInsiderPublisherId) {
        return false;
    }
    return true;
}